module.exports = __webpack_public_path__ + "img/process_img02.9cae0a8d.png";